import { render, staticRenderFns } from "./AppTrialExpiredWarning.vue?vue&type=template&id=3167134b&scoped=true"
import script from "./AppTrialExpiredWarning.vue?vue&type=script&lang=ts"
export * from "./AppTrialExpiredWarning.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3167134b",
  null
  
)

export default component.exports